import { render, staticRenderFns } from "./SubmitDialog.vue?vue&type=template&id=19622cae&scoped=true"
import script from "./SubmitDialog.vue?vue&type=script&lang=js"
export * from "./SubmitDialog.vue?vue&type=script&lang=js"
import style0 from "./SubmitDialog.vue?vue&type=style&index=0&id=19622cae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19622cae",
  null
  
)

export default component.exports